var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-template',[_c('fragment',[(_vm.group == 'atendente')?_c('HomeAtendente'):_vm._e(),(_vm.group == 'gestor')?_c('HomeGestor'):_vm._e(),(_vm.group == 'usuario')?_c('HomeUsuario'):_vm._e(),(_vm.group == 'whitelabel')?_c('HomeAdmin'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }